<template>
  <main>
    <wo-region>
      <wo-layout>
        <wo-title tag-name="h1"><span v-t="env.appTitleKey"></span></wo-title>
        <wo-grid>
          <wo-column width-md="6">
            <wo-typography  v-wo-color.light v-wo-text.xl>
              <p v-t="'general.appOnlyMessage'"> </p>
            </wo-typography>
          </wo-column>
        </wo-grid>
        <wo-spacer mod-xl />
        <wo-grid>
          <wo-column v-for="app in applications" :key="app.url" width-md="3">
            <a :href="app.url" class="po-app-link">
              <img :src="app.image" />
            </a>
          </wo-column>
        </wo-grid>
        <wo-spacer mod-xl />
        <wo-typography  v-wo-color.light v-wo-text.xl>
          <p>{{ accountMessage }} <po-route-link label-key="general.action.signOut" :value="signoutRoute" /></p>
        </wo-typography>
      </wo-layout>
    </wo-region>
  </main>
</template>

<script>

import { mapState } from 'vuex'
import { SIGNIN } from '@/routes/identity'

const IOS_IMAGE = '/images/app-store.png'
const ANDRIOD_IMAGE = '/images/google-play.png'

export default {
  name: 'MainView',
  computed: mapState({
    env: state => state.environment.current,
    user: state => state.identity.currentUser,
    signoutRoute: () => ({ name: SIGNIN, params: { signOut: true } }),
    applications () {
      return [
        this.createApp(this.env.iosAppUrl, IOS_IMAGE),
        this.createApp(this.env.androidAppUrl, ANDRIOD_IMAGE)
      ]
    },
    accountMessage () {
      return this.$t('general.accountSummary', this.user)
    }
  }),
  methods: {
    createApp (url, image) {
      return { url: url, image: image }
    }
  }
}
</script>

<style lang="scss">

.po-app-link {
  display: block;
  text-decoration: none;
  margin-bottom: 10px;
}

</style>
